let baseUrl = "https://api.pidigihub.in";

export { baseUrl };
